import { useCallback, useEffect, useState } from 'react';

import Option from '@/components/Option';
import Stack from '@/components/Stack';
import { FilterProps } from '@/filters';
import { CustomerFilterSetInput } from '@/types/graphql';

type Props = FilterProps<CustomerFilterSetInput> & {
  items: any[];
  filterKey: keyof CustomerFilterSetInput;
  isVertical?: boolean;
};

const StackGroupCheckFilters = ({
  filters,
  items,
  filterKey,
  onChangeFilter,
  onClearFilter,
  isVertical = false,
}: Props) => {
  const [selected, setSelected] = useState<any[]>(filters[filterKey] || []);

  const toggleSelected = useCallback(
    (value) => {
      if (selected?.includes(value)) {
        setSelected(selected.filter((item) => item !== value));
      } else {
        setSelected([...selected, value]);
      }
    },
    [selected]
  );

  useEffect(() => {
    if (selected.length > 0) {
      onChangeFilter(filterKey, selected);
    } else {
      onClearFilter(filterKey);
    }
  }, [selected]);

  return (
    <Stack gap={20} vertical={isVertical} wrap={true}>
      {items.map((item, index) => (
        <Option
          key={`${filterKey}-${index}`}
          appearance="checkbox"
          checked={selected?.includes(item.value)}
          id={`${index}-${filterKey}`}
          label={item.label}
          type="checkbox"
          value={item.value}
          onChange={(ev) => toggleSelected(ev.target.value)}
        />
      ))}
    </Stack>
  );
};

export default StackGroupCheckFilters;
